module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("新建申报")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    ref: "tabNavs",
    staticClass: "tabNavs"
  }, [_vm._l((_vm.navs), function(item, index) {
    return _c('div', {
      key: index,
      class: ['tabItem', {
        'act': _vm.navAct === index
      }],
      on: {
        "click": function($event) {
          _vm.tabChange($event, index)
        }
      }
    }, [_vm._v("\n                     " + _vm._s(item) + "\n                ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "moveLine",
    style: (_vm.lineStr)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tabContent"
  }, [_c('Subpage1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 0),
      expression: "navAct===0"
    }],
    ref: "subpage1",
    on: {
      "inited": _vm.readyHandle
    }
  }), _vm._v(" "), _c('Subpage2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 1),
      expression: "navAct===1"
    }],
    ref: "subpage2",
    on: {
      "inited": _vm.readyHandle
    }
  }), _vm._v(" "), _c('Subpage3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 2),
      expression: "navAct===2"
    }],
    ref: "subpage3",
    on: {
      "inited": _vm.readyHandle
    }
  }), _vm._v(" "), _c('Subpage4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 3),
      expression: "navAct===3"
    }],
    ref: "subpage4",
    on: {
      "inited": _vm.readyHandle
    }
  }), _vm._v(" "), _c('Subpage5', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navAct === 4),
      expression: "navAct===4"
    }],
    ref: "subpage5",
    on: {
      "inited": _vm.readyHandle
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 1) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 2) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.directSave(1)
      }
    }
  }, [_vm._v("立即发布")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ansSave
    }
  }, [_vm._v("发布并新建解读")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.directSave(3)
      }
    }
  }, [_vm._v("存为草稿")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("取消")])], 1)]), _vm._v(" "), _c('unsModel', {
    ref: "unsPop",
    on: {
      "goCreate": _vm.goCreate
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-70ac9130"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/declare/declareEdit.vue
// module id = 1520
// module chunks = 1